import { curry, includes, isArray, isObject, map } from 'lodash/fp';
import { CENSOR_STRING, SENSITIVE_DATA } from '../constants';
import { mapValuesWithKey } from './lodash-ext';
/**
 * Anonymize any sensitive data in given object
 *
 * @param {Function} censorFunc - function to anonymize data
 * @param {Array} sensitiveKeys - array of keys to be anonymized
 * @param {object} data - data to be anonymized
 * @returns {object} output
 *
 * @example
 * anonymizeData(
 *   { user: { first_name: 'John', last_name: 'Doe' }}
 * ) // returns { user: { first_name: '*******', last_name: '*******' }}
 */

export var anonymizeData = curry(function (censorFunc, sensitiveKeys, data) {
  var anonymizeRecursively = anonymizeData(censorFunc, sensitiveKeys);
  return mapValuesWithKey(function (value, key) {
    if (isArray(value)) {
      return map(function (item) {
        return isObject(item) ? anonymizeRecursively(item) : item;
      }, value);
    }

    if (isObject(value)) {
      return anonymizeRecursively(value);
    }

    return includes(key, sensitiveKeys) ? censorFunc(value) : value;
  }, data);
});
/**
 * Anonymize any user personal data in given object
 *
 * @param {object} data - data to be anonymized
 * @returns {object} output
 *
 * @example
 * anonymizeData(
 *   { user: { first_name: 'John', last_name: 'Doe' }}
 * ) // returns { user: { first_name: '*******', last_name: '*******' }}
 */

export var anonymizeUserData = anonymizeData(function () {
  return CENSOR_STRING;
}, SENSITIVE_DATA);